import PageHeader from "@/components/layout/PageHeader";
import ContactMap from "@/components/home/ContactMap";
import { BUSINESS } from "@/lib/constants";

export default function FindUs() {
  return (
    <>
      <PageHeader
        eyebrow="Find Us"
        title="Our counter is right next to Bally Toll Plaza."
        subtitle={BUSINESS.address}
        primary={{ to: "/contact", label: "Contact Us" }}
      />
      <ContactMap />
    </>
  );
}
